module.exports = __webpack_public_path__ + "static/img/icono-ojo.506aeabe.svg";